module.exports = __webpack_public_path__ + "img/9_20.141fc67c.png";